<style scoped>  

  @media only screen and (max-width: 767px) {
    .search-button {
      margin-top: 16px;
    }
  }

  @media only screen and (min-width: 768px) {
    .search-button {
      margin-top: 24px;
    }
  }

</style>

<template>
  
  <div class="ui segment animated fadeIn">

    <form class="ui form" @submit.prevent="onSearch()">      
      <div class="fields">
        <div class="three wide field">
          <label>Data Inicial <span class="red text">*</span></label>
          <div id="invoices-start-date" class="ui calendar">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" class="date">
            </div>
          </div>
        </div>
        <div class="three wide field">
          <label>Data Final <span class="red text">*</span></label>
          <div id="invoices-end-date" class="ui calendar">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" class="date">
            </div>
          </div>
        </div>
        <div class="three wide field">
          <button type="submit" class="ui basic blue icon button search-button" :class="{ loading }">
            <i class="search icon"></i>
            Pesquisar
          </button>
        </div>
      </div>
    </form>

    <div v-if="invoices && invoices.length > 0" class="ui segment animated fadeIn m-t-20">
      <table class="ui very basic celled selectable tablet stackable table">
        <thead class="desktop-only">
          <tr>
            <th>Filial</th>
            <th>Número</th>
            <th>Série</th>
            <th>Emissão</th>
            <th>Entrega</th>
            <th>Transportadora</th>
            <th>Valor Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="invoice in invoices" class="clickable" @click="onShowInvoice(invoice)">            
            <td><strong class="mobile-only">Filial: </strong>{{ invoice.branch + ' - ' + $branchName(invoice.branch) }}</td>
            <td><strong class="mobile-only">Número: </strong>{{ invoice.number }}</td>
            <td><strong class="mobile-only">Série: </strong>{{ invoice.series }}</td>
            <td><strong class="mobile-only">Emissão: </strong>{{ $formatDate(invoice.date) }}</td>
            <td><strong class="mobile-only">Entrega: </strong>{{ $formatDate(invoice.deliveryDate) }}</td>
            <td><strong class="mobile-only">Transportadora: </strong>{{ invoice.carrier }}</td>
            <td><strong class="mobile-only">Valor Total: </strong>R$ {{ $formatCurrency(invoice.total) }}</td>
          </tr>          
        </tbody>
      </table>
    </div>

    <invoice-dialog ref="invoiceDialog" :branchId="selectedInvoice.branch"
      :number="selectedInvoice.number" :series="selectedInvoice.series" />

  </div>

</template>

<script>

  import { Message, Calendar } from "@/utils"
  import InvoiceDialog from "@/components/invoice-dialog.vue"
  import InvoiceService from "@/services/invoice-service"

  export default {    

    data() {
      return {
        loading: false,
        invoices: null,
        selectedInvoice: {},
      }
    },
    
    props: ["customer"],

    components: {
      InvoiceDialog
    },

    mounted() {

      Calendar.initInputs()
    },

    methods: {

      async onSearch() {

        let startDate = $("#invoices-start-date").calendar("get date")
        let endDate = $("#invoices-end-date").calendar("get date")

        if (!startDate || !endDate) {
          Message.info("Defina o intervalo de datas")
          return
        }

        this.loading = true

        try {

          this.invoices = await InvoiceService.getCustomerInvoices({            
            startDate,
            endDate,
            customerCode: this.customer.code,
            customerUnit: this.customer.unit,                  
          })

          this.loading = false

          if (this.invoices.length == 0)
            Message.info("Nenhum registro encontrado")
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },

      onShowInvoice(invoice) {

        this.selectedInvoice = invoice
        
        this.$refs.invoiceDialog.show()
      },
    },

  }

</script>

